import { NgModule } from '@angular/core';
import { PxSuffixPipe } from './px-suffix.pipe';
import { ReplacePipe } from './replace.pipe';

const imports = [ReplacePipe, PxSuffixPipe];

@NgModule({
  imports,
  exports: imports,
})
export class PipesModule {}
